import { useGT } from 'gt-react';
import { SidebarSimpleIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

export function ActionsSidebarToggle({
  open,
  onToggle,
}: {
  open: boolean;
  onToggle: () => void;
}) {
  const gt = useGT();
  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-7 w-7 shrink-0"
      onClick={onToggle}
      aria-label={
        open
          ? gt('Collapse actions panel', {
              context: 'aria label for the actions sidebar toggle button',
            })
          : gt('Expand actions panel', {
              context: 'aria label for the actions sidebar toggle button',
            })
      }
    >
      <SidebarSimpleIcon className="h-4 w-4" />
    </Button>
  );
}
